import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { CustomerObject } from 'src/app/_interfaces/cinema/CustomerObject';
import { environment } from 'src/environments/environment';
const API_URL = environment.prismaApiUrl +'/api/dispo/customer-branches';
@Injectable({
 providedIn: 'root'
})
export class CustomerBranchService {
currentObject: any;
isNew: Boolean = false;

        constructor(private http: HttpClient) { }

        getAll(): Observable<any> {
            return this.http.get(API_URL);
        }

        store(object: any): Observable<any> {
            return this.http.post<CustomerObject>(API_URL, {data: object});
        }
        byCustomerId(object: any): Observable<any> {
            return this.http.get(API_URL + '/byCustomerId/' + object);
        }

        delete(object: any): Observable<any> {
            return this.http.delete(API_URL + '/' + object.id);
        }

       show(id: any): Observable<any> {
            console.log('cb_id'+ id);
            this.currentObject = this.http.get(API_URL + '/' + id);
            return this.currentObject;
        }

        /** Koordinaten für Filiale aus Adresse ermitteln und speichern. */
        geocodeBranchCoords(branchId: number): Observable<{ lat: number; lng: number }> {
            return this.http.post<{ lat: number; lng: number }>(API_URL + '/geocode-coords/' + branchId, {});
        }

        /** Zugeordnete Teams inkl. Priorität für automatisierte Dispo-Buchungen. */
        getBranchTeams(branchId: number): Observable<any> {
            return this.http.get(API_URL + '/' + branchId + '/teams');
        }

        /** Team-Reihenfolge speichern (erstes Team = primär). */
        reorderBranchTeams(branchId: number, teamIds: number[]): Observable<any> {
            return this.http.put(API_URL + '/' + branchId + '/teams/reorder', { team_ids: teamIds });
        }

        update(object: any): Observable<any> {
            return this.http.put<CustomerObject>(API_URL + '/' + object.id, {data: object});
        }

        genPDF(): Observable<any> {
            return this.http.get(API_URL + '/gen-pdf', {responseType: 'arraybuffer'});
        }

        getCurrentObject() {
            return this.currentObject;
        }

        setIsNew(value: any) {
            this.isNew = value;
        }

        getIsNew() {
            return this.isNew;
        }
      }
